var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.637085 0.208496V7.32516H7.75375V35.7918H14.8704V7.32516H21.9871V0.208496H0.637085Z",
    fill: "#33697A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectort);
export default __webpack_public_path__ + "static/media/Vectort.bb048640d6c2e73f1c74be3e8f55c163.svg";
export { ForwardRef as ReactComponent };